
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './AboutUsCard.css';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink'
import { ButtonWrapper } from '../LinkWrapper/LinkWrapper';
import Title from '../../component-library/atoms/Title/Title';
import { Row, Col } from '../../importCL';

interface IAboutUsCardProps extends MappedComponentProperties {
    imagePath?: string;
    imageAltText?: string;
    headline?: string;
    text?: string;
    heading?: string;
    address?: string;
    linkText?: string;
    linkUrl?: string;
}

export const AboutUsCardEditConfig = {
    emptyLabel: 'About Us Card',
    isEmpty: (props: PropsWithChildren<IAboutUsCardProps>) => {
        return !props || !props.headline;
    },
};

const AboutUsCard = (props: PropsWithChildren<IAboutUsCardProps>): JSX.Element => {
    return (
        <section id='about-us-card' className={'AboutUsCard flex md:flex-col max-w-[72rem] m-auto'}>
            <div className='pb-[3.625rem] md:pb-0 pl-4 md:pr-4 z-10'>
                <Title
                    tag={'h2'}
                    className={`Section__title mt-8 !mb-0 py-2`}
                    verticalBar={true}
                >
                    {transformHTMLParserLinks(props.headline || 'About Us')}
                </Title>
                <Row className={'AboutUsCard__text bg-light-blue md:flex-col p-4 w-[110%] md:w-full !m-0 -bottom-8 relative'}>
                    <Col className='!w-56 !pr-4 md:!pr-0 !pl-0 self-center'>
                        {transformHTMLParserLinks(props.text ?? '')}
                        {(props.linkText && props.linkUrl) && <ButtonWrapper 
                            className='!justify-start !p-0 mb-0 mt-6 md:mb-8'
                            icon={'chevron'}
                            href={props.linkUrl}
                            size={'medium'}
                            target={'_self'}
                            variant={'link'}>
                            {transformHTMLParserLinks(props.linkText ?? '')}
                        </ButtonWrapper>}
                    </Col>
                    {(props.heading || props.address) && (
                        <>
                            <div className='height-100 border border-solid border-gray-300' />
                            <Col xs={5} className='!pl-8 !pr-6 md:mt-8 md:!pl-0'>
                                {props.heading && <h5>{props.heading}</h5>}
                                {props.address && (
                                    <>
                                        <p className='text-blue-creditone font-bold !mb-2 mt-4'>Address:</p>
                                        <p className='AboutUsCard__address'>{transformHTMLParserLinks(props.address)}</p>
                                    </>
                                )}
                            </Col>
                        </>
                    )}
                </Row>
            </div>
            <div aria-label={props.imageAltText ?? 'About Us Card Image'}
                className={'AboutUsCard__image aspect-square w-full max-w-[25.875rem] md:max-w-full bg-center bg-cover'}
                style={{ backgroundImage: `url(${props.imagePath})` }} 
                role={'img'}/>
        </section>
    );
};

export default AboutUsCard;
